<template>
      <dialog-template
        :openDialog="isOpen"
        :widthDialog="'1400px'"
        :classDialog="'dialog-doc-out-finish'"
        @closeDialog="$emit('closeDialog')"
        @closed="$emit('closed')"
        :appendToBody="true"
        :modalAppendToBody="true"
      >
        <template #body>
          <div id="pageContainer">
            <el-row :gutter="12" class="">
              <el-col>
                <div class="titleText">Đóng dấu văn bản đến</div>
              </el-col>
              <el-col>
                <div class="menuButton">
                  <div class="pAddShape flex-row flex__left">
                    <canvas-tool-button
                      :label="'Xoá'"
                      :iconClass="'fas fa-trash font-size__medium color__red '"
                      @click="deleteObjectEvent"
                      :disabled="false"
                    >
                    </canvas-tool-button>
                    <canvas-font-size
                      @fontSizeChanged="setFontSize"
                      :disabled="false"
                    ></canvas-font-size>
                    <canvas-buttons-group
                      :disabled="false"
                      @alignChanged="setAlign"
                      :buttonConfigs="alignmentButtonConfigs"
                    ></canvas-buttons-group>
                    <canvas-buttons-group
                      :disabled="false"
                      @alignChanged="setFontStyle"
                      :buttonConfigs="fontStyleButtonConfigs"
                    ></canvas-buttons-group>
                  </div>
                </div>
              </el-col>
              <el-col :span="18" class="pDetailDocs">
                <VuePerfectScrollbar :class="['pScroll scrollSignature']">
                <div v-if="pages.length" style="width: 100%;">
                  <div style="width: 100%;">
                    <div v-for="(page, pIndex) in pages" :key="pIndex">
                      <div
                        style="padding: 1.25rem; width: 100%; display: flex; flex-direction: column; align-items: center; overflow: hidden;"
                        @mousedown="selectPage(pIndex)"
                        @touchstart="selectPage(pIndex)">
                        <div
                          style="position: relative; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);"
                          :class="[pIndex === selectedPageIndex ?'shadowOutline':'']">
                          <PDFPage
                            :ref="`page${pIndex}`"
                            :data-key="pIndex"
                            @onMeasure="onMeasure($event, pIndex)"
                            @onClick="getCoordinatesAndAddText"
                            :page="page"/>
                          <div
                            style="position: absolute; top: 0; left: 0; transform-origin: top left;"
                            class="noTouchAction"
                            :style="{transform: `scale(${pagesScale[pIndex]})`}"
                          >
                            <div v-for="(object, oIndex) in allObjects[pIndex]" :key="oIndex">
                              <div>
                                <div v-if="object.type === 'image'">
                                  <ImageItem
                                    @onUpdate="updateCoordinate(object.id, $event)"
                                    @onClick="updateCurrentObj(object)"
                                    :file="object.file"
                                    :payload="object.payload"
                                    :x="object.x"
                                    :y="object.y"
                                    :width="object.width"
                                    :height="object.height"
                                    :originWidth="object.originWidth"
                                    :originHeight="object.originHeight"
                                    :pageScale="pagesScale[pIndex]"/>
                                </div>
                                <div v-if="object.type === 'text'">
                                  <TextItem
                                    @onUpdate="updateCoordinate(object.id, $event)"
                                    @onClick="updateCurrentObj(object)"
                                    :text="object.text"
                                    :x="object.x"
                                    :y="object.y"
                                    :size="object.size"
                                    :lineHeight="object.lineHeight"
                                    :fontFamily="object.fontFamily"
                                    :textAlign="object.align"
                                    :fontWeight="object.fontWeight"
                                    :fontStyle="object.fontStyle"
                                    :pageScale="pagesScale[pIndex]"
                                    :transparent="'white'"
                                    :textEditable="false"/>
                                </div>
                                <div v-if="object.type === 'textTransparent'">
                                  <TextItem
                                    @onUpdate="updateCoordinate(object.id, $event)"
                                    @onClick="updateCurrentObj(object)"
                                    :text="object.text"
                                    :x="object.x"
                                    :y="object.y"
                                    :size="object.size"
                                    :lineHeight="object.lineHeight"
                                    :fontFamily="object.fontFamily"
                                    :textAlign="object.align"
                                    :fontWeight="object.fontWeight"
                                    :fontStyle="object.fontStyle"
                                    :pageScale="pagesScale[pIndex]"
                                    :textEditable="object.textEditable"
                                    :transparent="''"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </VuePerfectScrollbar>
              </el-col>
              <el-col :span="6" class="pListThumb">
                <VuePerfectScrollbar :class="['pScroll scrollSignature']" style="margin-top: 38px;">
                  <div class="pListThumb-Title">
                    <div
                      class="pListThumb-Title"
                      v-if="textImages && textImages.length"
                    >
                      <h2 style="margin-left: 25%; color: var(--color-blue);" class="">
                        {{ "Thông tin văn bản" }}
                      </h2>
                    </div>
                    <clickableTextImage
                      v-for="item in textImages"
                      :key="item.id"
                      :text="item.value"
                      :title="getPImageTitle(item)"
                      @addDateTimeImg="event => getTextNormal(event)"
                    />
                  </div>
                  <div class="pListThumb-Title" v-if="listStamp && listStamp.length">
                    <h2 style="margin-left: 25%;" class="margin-botom-10 margin-top-10">
                      {{ "Danh sách con dấu" }}
                    </h2>
                  </div>
                  <clickableImage
                    v-for="(item, $index) in listStamp"
                    :key="`stamp_${$index}`"
                    :url="item.url"
                    :title="item.title"
                    @addImg="event => addImageStamp(event)"
                  ></clickableImage>
                  <div class="pListThumb-Title" v-if="signatureImages && signatureImages.length">
                    <h2 style="margin-left: 25%;" class="margin-botom-10 margin-top-10">
                      {{ "Danh sách chữ ký" }}
                    </h2>
                  </div>
                  <clickableSignature
                    v-for="(item, $index) in signatureImages"
                    :key="`signature_${$index}`"
                    :url="item.url"
                    :text="item.value"
                    :title="getPImageTitle(item)"
                    @addSignature="event => addSignature(event)"
                  ></clickableSignature>
                </VuePerfectScrollbar>
              </el-col>
            </el-row>

          </div>
        </template>
        <template #footer>
          <div class="flex-row flex__left form-button__action">
            <div>
              <el-button
                class="dialogBtnSecondary"
                @click="submitPDF"
                :disabled="isSubmitting"
              >
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isSubmitting
                    ? 'fas fa-save'
                    : 'el-icon-loading'
                ]"
              ></i>
              &nbsp;Xác nhận
            </span>
              </el-button>
            </div>
          </div>
        </template>
      </dialog-template>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/build/pdf";
// import {PDFViewer} from "pdfjs-dist/web/pdf_viewer";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import buildAttachmentImage from "../../../filters/buildAttachmentImage";
import "pdfjs-dist/web/pdf_viewer.css";
import dateUtils from "../../../dateUtils";
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import utils from "../../../services/utils";
import {fetchFont} from "./pdf-lib-utils/prepareAssets";
import TextItem from "./pdf-lib-contents/TextItem.vue";
import ImageItem from "../components/pdf-lib-contents/Image.vue";
import PDFPage from "./pdf-lib-contents/PDFPage.vue";
import {readAsImage, readAsPDF} from "./pdf-lib-utils/asyncReader";
import {save} from "./pdf-lib-utils/PDF";
import Konva from "konva"
import CanvasToolButton from "../../common/noteDocs/canvas-tool-button.vue";
import CanvasFontSize from "../../common/noteDocs/canvas-font-size-vb-den.vue";
import CanvasButtonsGroup from "../../common/noteDocs/canvas-buttons-group.vue";
import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
import attachmentService from "../../../services/attachmentService";
// import h from "../../../services/h";
import clickableSignature from "./pdf-lib-contents/clickableSignature.vue";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.4.456/pdf.worker.js";

export default {
  name: "kyTokenDialogDocIn",
  data() {
    return {
      pdfFile: null,
      pdfName: "",
      numPages: 0,
      pageNumber: 0,
      textImages: [],
      signatureImages: [],
      pdfDocument: null,
      // attachment8ArrayCode: null,
      currentFont: 'Times-Roman',
      coordinates: {
        x: 0,
        y: 0,
      },
      eventText: "",
      eventImageUrl: null,
      stampAdded: false, // Thêm biến để đánh dấu xem con dấu đã được kéo vào hay chưa
      signatureObj: null,
      pages: [],
      pagesScale: [],
      allObjects: [],
      selectedPageIndex: -1,
      selectedFont: constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE_VB_DEN,
      focusId: null,
      listStamp: [],
      listAttachmentStamp: [],
      isSubmitting: false,
      scale: constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_96_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI,
      currentObject: null,
      alignmentButtonConfigs: [
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.LEFT,
          label: "Căn trái",
          iconClass: "fas fa-align-left"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.CENTER,
          label: "Căn giữa",
          iconClass: "fas fa-align-center"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.RIGHT,
          label: "Căn phải",
          iconClass: "fas fa-align-right"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.JUSTIFY,
          label: "Dàn đều",
          iconClass: "fas fa-align-justify"
        }
      ],
      fontStyleButtonConfigs: [
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL,
          label: "Bình thường",
          iconClass: "fas fa-ad"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.BOLD,
          label: "Đậm",
          iconClass: "fas fa-bold"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC,
          label: "Nghiêng",
          iconClass: "fas fa-italic"
        }
      ],
      isAddIssuedBookNumber: false
    };
  },
  props: [
    "isOpen",
    "docDate",
    "bookNumber",
    "publisherDept",
    "signDate",
    "docUrl"
  ],

  filters: {buildAttachmentURL, buildAttachmentImage},

  async mounted() {
     await this.init();
     await this.initTextImages();
  },
  components: {
    clickableSignature,
    CanvasButtonsGroup,
    CanvasFontSize,
    CanvasToolButton,
    PDFPage,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    clickableTextImage: () => import("../components/pdf-lib-contents/clickableTextImage.vue"),
    clickableImage: () => import("../components/pdf-lib-contents/clickableImage.vue"),
    TextItem,
    ImageItem
  },

  computed: {
    pageHeight() {
      const {canvasHeight} =
        // eslint-disable-next-line standard/computed-property-even-spacing
        this.$refs[
          `page${this.selectedPageIndex}`
          ][0].getCanvasMeasurement();

      return canvasHeight;
    },
  },

  methods: {
    resetEventTextImage() {
      this.eventText = "";
      this.eventImageUrl = null;
      this.signatureObj = null;
    },

    getCoordinatesAndAddText(payload) {
      this.coordinates = payload;
      if (this.eventText !== "" && this.selectedPageIndex >= 0) {
        if (this.eventText === constants.TEXT_VALUE.DEFAULT_TEXT) {
          this.addTextTransparentField(this.eventText);
        } else {
          this.addTextField(this.eventText);
        }
        this.resetEventTextImage();
        return;
      }
      if (this.eventImageUrl !== null && this.selectedPageIndex >= 0) {
        this.addImage(this.eventImageUrl);
        this.resetEventTextImage();
        return;
      }
      if (this.signatureObj !== null && this.selectedPageIndex >= 0) {
        if (this.signatureObj.url !== null) {
          this.addTextImage(this.signatureObj);
        } else {
          this.addTextTransparentField(this.signatureObj.text);
        }
        this.resetEventTextImage();
      }
    },

    async init() {
      try {
        const res = await fetch(this.docUrl);
        const pdfBlob = await res.blob();
        await this.addPDF(pdfBlob);
        this.selectedPageIndex = 0;
        setTimeout(() => {
          fetchFont(this.currentFont);
          // prepareAssets();
        }, 5000);
      } catch (e) {
        console.log(e);
      }
    },

    setFontSize(event) {
      this.selectedFont = event;

      if (this.currentObject !== null) {
        this.currentObject.size = event;
        this.updateCoordinate(this.currentObject.id, this.currentObject);
      }
    },

    setAlign(event) {
      if (this.currentObject !== null) {
        this.currentObject.align = event;
        this.updateCoordinate(this.currentObject.id, this.currentObject);
      }
    },

    setFontStyle(event) {
      if (this.currentObject !== null) {
        if (event === constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC) {
          this.currentObject.fontStyle = event;
        } else {
          this.currentObject.fontWeight = event;
          this.currentObject.fontStyle = '';
        }
        this.updateCoordinate(this.currentObject.id, this.currentObject);
      }
    },

    deleteObjectEvent() {
      if (this.currentObject !== null) {
        let index = this.allObjects[this.selectedPageIndex].findIndex(obj => obj.id === this.currentObject.id);
        if (index > -1) {
          let objects = this.allObjects[this.selectedPageIndex];
          let objectToDelete = {}; // Khởi tạo một đối tượng trống

          // Gán giá trị cho objectToDelete dựa trên loại của đối tượng hiện tại
          if (objects[index].type === 'image') {
            objectToDelete = {
              id: null,
              type: null,
              width: null,
              height: null,
              originWidth: null,
              originHeight: null,
              x: 0,
              y: 0,
              payload: null,
              file: null,
              pIndex: 0,
              pageHeight: null
            };
          } else if (objects[index].type === 'text' || objects[index].type === 'textTransparent') {
            objectToDelete = {
              id: null,
              text: null,
              type: null,
              size: null, // recalculate after editing
              lineHeight: null,
              fontFamily: null,
              x: 0,
              y: 0,
              align: null,
              fontWeight: null,
              fontStyle: null,
              pIndex: 0,
              pageHeight: null
            }
          }

          // Gán đối tượng xóa vào vị trí của đối tượng cần xóa trong mảng allObjects
          this.allObjects = this.allObjects.map((objects, pIndex) =>
            pIndex === this.selectedPageIndex
              ? objects.map(object =>
                (object.id === this.currentObject.id ? {...object, ...objectToDelete} : object)
              )
              : objects
          );

          this.stampAdded = false; // Đặt lại giá trị của biến stampAdded về false
        }
      }
    },

    addImageStamp(url) {
// Chỉ cho phép kéo vào nếu chưa có con dấu nào được kéo vào
      if (!this.stampAdded) {
        this.eventImageUrl = url;
        this.stampAdded = true; // Đánh dấu rằng con dấu đã được kéo vào
      }
      },

    addSignature(signature) {
      this.signatureObj = signature;
    },

    getTextNormal(text) {
      this.eventText = text;
    },

    onMeasure(e, i) {
      this.pagesScale[i] = e.scale;
    },

    async addPDF(file) {
      try {
        this.resetDefaultState();

        this.pdfFile = file;
        this.pdfName = "test file";

        this.pdfDocument = await readAsPDF(file);
        if (this.pdfDocument) {
          this.numPages = this.pdfDocument.numPages;
          this.pages = Array(this.numPages)
            .fill()
            .map((_, i) => this.pdfDocument.getPage(i + 1));
          this.allObjects = this.pages.map(() => []);
          this.pagesScale = Array(this.numPages).fill(1);
        }
      } catch (e) {
        console.log("Failed to add pdf.");
        throw e;
      }
    },

    resetDefaultState() {
      this.pdfFile = null;
      this.pdfName = "";
      this.numPages = null;
      this.pdfDocument = null;
      this.pages = [];
      this.pagesScale = [];
      this.allObjects = [];
    },

    getPImageTitle(textImage) {
      switch (textImage.type) {
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO:
          return errorMessageFilter({
            errorCode: "signToken.publisherInfo.title"
          });
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.BOOK_NUMBER:
          return errorMessageFilter({errorCode: "signToken.soDen.title"});
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
          return errorMessageFilter({errorCode: "signToken.incomingDate.title"});
        default:
          return "";
      }
    },

    initTextImages() {
      let docDate_ = dateUtils.toMoment(this.docDate);
      let now_ = dateUtils.toMoment(this.signDate.getTime());

      // Hàm gọi API và xử lý kết quả cho con dấu vbDen
      const fetchVbDenStamp = () => {
        return attachmentService.findAll({
          objectId: this.publisherDept.id + 'vbDen',
          objectType: constants.ATTACHMENT_OBJECT_TYPE.STAMP
        })
          .then(response => {
            if (response.data && response.data.length) {
              const vbAttachment = response.data[0];
              return vbAttachmentTokenService.getToken(vbAttachment.id)
                .then(res => {
                  return {
                    url: buildAttachmentURL(res.data.token, {
                      type: constants.DOWNLOAD_OPTION.TYPE.STAMP
                    }),
                    title: 'Con dấu'
                  };
                });
            } else {
              return null; // Trả về null nếu không tìm thấy dấu
            }
          });
      };

      // Hàm gọi API và xử lý kết quả cho con dấu mới (vd: ConDau2)
      const fetchNewStamp = (objectId) => {
        return attachmentService.findAll({
          objectId: this.publisherDept.id + objectId,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.STAMP
        })
          .then(response => {
            if (response.data && response.data.length) {
              const attachment = response.data[0];
              return vbAttachmentTokenService.getToken(attachment.id)
                .then(res => {
                  return {
                    url: buildAttachmentURL(res.data.token, {
                      type: constants.DOWNLOAD_OPTION.TYPE.STAMP
                    }),
                    title: 'Con dấu 2'
                  };
                });
            } else {
              return null; // Trả về null nếu không tìm thấy dấu
            }
          });
      };

      // Gọi API cho cả vbDen và ConDau2
      Promise.all([
        fetchVbDenStamp(),
        fetchNewStamp('ConDau2') // Thay 'ConDau2' bằng objectId của con dấu mới
      ])
        .then(results => {
          // Lọc ra các kết quả không null và thêm vào listStamp
          this.listStamp.push(...results.filter(result => result !== null));
        })
        .catch(error => {
          console.error('Error fetching stamps:', error);
        });


      this.textImages = [];

      this.textImages.push({
        id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.BOOK_NUMBER,
        type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.BOOK_NUMBER,
        value: errorMessageFilter({
          errorCode: "signToken.bookNumber",
          params: [this.bookNumber]
        }),
        fontConfig: {
          fontStyle: "normal",
          additionalWidth: 50,
          minLength: 200
        }
      });

      this.textImages.push({
        id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
        type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
        value: utils.convertDateTime(docDate_),
        fontConfig: {additionalWidth: 100}
      });

      this.textImages.push({
        id: 'textEditable',
        type: 'textEditable',
        value: errorMessageFilter({
          errorCode: "signToken.defaultText",
          params: [constants.TEXT_VALUE.DEFAULT_TEXT]
        }),
        fontConfig: {
          fontStyle: "normal",
          additionalWidth: 50,
          minLength: 200
        }
      });

      this.signatureImages.push({
        url: null,
        id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
        type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
        value: errorMessageFilter({
          errorCode: "signToken.publisherInfo",
          params: [
            this.publisherDept.deptName,
            // now_.format("DD/MM/YYYY; HH:mm:ss")
            this.isAddIssuedBookNumber ?
              docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
              : now_.format("DD/MM/YYYY; HH:mm:ss")
          ]
        }),
        fontConfig: {
          fontStyle: "normal",
          fontColor: "black",
          additionalWidth: 0
        }
      });
    },

    genID() {
      let uniqueId = 'id-' + Math.random().toString(36).substr(2, 9);
      return uniqueId;
    },

    updateCurrentObj(object) {
      this.currentObject = object;
    },

    initKonva(width, height) {
      const konvaContainer = document.createElement("konvaContainer");

      const stage = new Konva.Stage({
        container: konvaContainer,
        width: width,
        height: height
      });
      return stage;
    },

    async addImage(url) {
      const img = await readAsImage(url);

      const maxWidth = 120;
      const maxHeight = 90;

      // Preserve aspect ratio
      let ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
      let normalWidth = Math.round(img.width * ratio);
      let normalHeight = Math.round(img.height * ratio);

      const upscaleWidth = Math.round(normalWidth / this.scale);
      const upscaleHeight = Math.round(normalHeight / this.scale);
      const id = this.genID();

      //Create stage
      let stage = this.initKonva(upscaleWidth, upscaleHeight);

      // Create a new layer
      let layer = new Konva.Layer();

      //Create konva Image
      let konvaImage = new Konva.Image({
        x: 0,
        y: 0,
        image: img,
        width: upscaleWidth,
        height: upscaleHeight
      });

      // Add the image to the layer
      layer.add(konvaImage);

      // Add the layer to stage
      stage.add(layer);

      stage.draw();

      const dataUrl = stage.toDataURL();

      const finalImage = await readAsImage(dataUrl);

      const object = {
        id,
        type: "image",
        width: normalWidth,
        height: normalHeight,
        originWidth: normalWidth,
        originHeight: normalHeight,
        x: this.coordinates.x,
        y: this.coordinates.y,
        payload: finalImage,
        file: dataUrl,
        pIndex: this.selectedPageIndex,
        pageHeight: this.pageHeight
      };

      this.currentObject = object;

      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex ? [...objects, object] : objects
      );
    },

    async addTextField(text) {
      const id = this.genID();
      fetchFont(this.currentFont);

      const size = this.selectedFont;

      const object = {
        id,
        text,
        type: "textTransparent",
        size: size,// recalculate after editing
        lineHeight: 1.4,
        fontFamily: this.currentFont,
        x: this.coordinates.x,
        y: this.coordinates.y,
        align: 'left',
        fontWeight: 'normal',
        fontStyle: '',
        pIndex: this.selectedPageIndex,
        pageHeight: this.pageHeight
      };

      this.currentObject = object;

      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex ? [...objects, object] : objects
      );
    },

    async addTextTransparentField(text) {
      const id = this.genID();
      fetchFont(this.currentFont);

      const size = this.selectedFont;

      let textEditable;
      if (text === constants.TEXT_VALUE.DEFAULT_TEXT) {
        textEditable = true;
      } else {
        textEditable = false;
      }

      const object = {
        id,
        text,
        type: "textTransparent",
        size: size,// recalculate after editing
        lineHeight: 1.4,
        fontFamily: this.currentFont,
        x: this.coordinates.x,
        y: this.coordinates.y,
        align: 'left',
        fontWeight: 'normal',
        fontStyle: '',
        pIndex: this.selectedPageIndex,
        pageHeight: this.pageHeight,
        textEditable
      };

      this.currentObject = object;

      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex ? [...objects, object] : objects
      );
    },

    async addTextImage(obj) {
      const img = await readAsImage(obj.url);
      const id = this.genID();

      let imageWidth;
      if (img.width > img.height) {
        imageWidth = 220;
      } else {
        imageWidth = 180;
      }
      const imageHeight = 180;

      // Create a new layer
      let layer = new Konva.Layer();

      //Create konva Image
      let konvaImage = new Konva.Image({
        x: 0,
        y: 0,
        image: img,
        width: imageWidth,
        height: imageHeight
      });

      // create a new Konva text node
      let konvaText = new Konva.Text({
        x: konvaImage.x() + konvaImage.width() + 10,
        y: imageHeight / 4,
        text: obj.text,
        fontSize: 37,
        fontFamily: 'Times New Roman',
        fill: 'black'
      });

      // Add the image to the layer
      layer.add(konvaImage);
      layer.add(konvaText);

      const upscaleWidth = konvaText.textWidth + 10 + konvaImage.width();
      const upscaleHeight = konvaImage.height();

      //Create stage
      let stage = this.initKonva(upscaleWidth, upscaleHeight);

      // Add the layer to stage
      stage.add(layer);

      stage.draw();


      const dataUrl = stage.toDataURL();

      const finalImage = await readAsImage(dataUrl);

      const object = {
        id,
        type: "image",
        width: upscaleWidth / 2,
        height: upscaleHeight / 2,
        originWidth: upscaleWidth,
        originHeight: upscaleHeight,
        x: this.coordinates.x,
        y: this.coordinates.y,
        payload: finalImage,
        file: dataUrl,
        pIndex: this.selectedPageIndex,
        pageHeight: this.pageHeight
      };

      this.currentObject = object;

      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex ? [...objects, object] : objects
      );
    },

    updateCoordinate(objectId, payload) {
      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex
          ? objects.map(object =>
            (object.id === objectId ? {...object, ...payload} : object)
          )
          : objects
      );
    },

    selectPage(index) {
      this.selectedPageIndex = index;
    },

    deleteObject(objectId) {
      this.allObjects = this.allObjects.map((objects, pIndex) =>
        pIndex === this.selectedPageIndex ?
          objects.filter(object => object.id !== objectId)
          : objects
      );
    },

    async submitPDF() {
      if (!this.pdfFile || this.isSubmitting || !this.pages.length) return;
      this.isSubmitting = true;
      try {
        const imageObjects = await save(this.pdfFile, this.allObjects);
        this.$emit("imageObjects", imageObjects);
      } catch (e) {
        console.log(e);
      } finally {
        this.isSubmitting = false;
      }
    },
  }
};
</script>

<style scoped lang="css">
#pageContainer {
  margin: auto;
}

.stepper {
  display: flex;
  align-items: center;
  justify-content: left;
  position: relative;
  padding-top: 3%;
  padding-bottom: 2%;
}

.stepper .info {
  padding-left: 10px;
  padding-right: 10px;
}

.scrollSignature .pListThumb-Title {
  color: var(--color-blue);
}

.pListThumb-Title {
  margin-bottom: 12px;
}

.pScroll {
  max-height: calc(100vh - 200px);
  height: auto;
  margin-top: 22px;
  /* margin-bottom: 10px; */
}

.pScroll.scrollSignature {
  margin-top: 58px;
  max-height: calc(100vh - 200px);
}

.pScroll.scrollWatchingNote {
  max-height: calc(100vh - 200px);
}

.pThumb {
  max-width: calc(100% - 10px);
  height: 100%;
  max-height: 350px;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #ceced2;
  position: relative;
  transition: all 0.25s ease-in-out;
}

.pThumb.active {
  border: 2px solid #007aff;
  transition: all 0.25s ease-in-out;
}

.pThumb .markIsModified.off {
  visibility: hidden;
}

.pThumb .markIsModified.on {
  visibility: visible;
}

.pThumb .markIsModified {
  position: absolute;
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
  background-color: #e54d42;
  top: 3px;
  right: 3px;
  border-radius: 50%;
}

.pThumb .pBgThumb {
  max-width: 90%;
  width: 100%;
  height: 150px;
  margin: 0 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.pDetailDocs {
  max-height: calc(100vh - 100px);
  height: auto;
}

.pControl {
  padding: 10px 0;
  height: 56px;
}

.pDetail {
  max-height: calc(100vh - 100px);
  height: auto;
}

.pScrollDoc {
  max-height: calc(100vh - 165px);
  height: auto;
  border: 1px solid #abb4bd;
  border-bottom-color: transparent;
  border-radius: 8px 0 0 0;
}

.pScrollDoc.pWatchingNote {
  margin-top: 56px;
}

.page-center > div {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: calc(100vh - 140px);
  height: calc(100vh - 140px);
  position: relative;
}

.BtnEdit {
  background-color: #efeff4;
  border: 1px solid red;
  font-size: 18px;
}

.BtnEdit.el-button.is-disabled {
  border: 1px solid red;
}

header {
  background: #1b1b1d;
}

.pListThumb {
  max-height: calc(100vh - 100px);
  height: auto;
  padding-top: 3%;
  padding-left: 3%;
}

.menuButton {
  position: absolute;
  left: 25%;
  top: 2%;
}

.titleText {
  position: absolute;
  top: 2%;
  font-size: 28px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/kyTokenDialogDocIn.vue